import { Component, OnInit } from "@angular/core";
import { MENU } from "../../../settings/menu";
import { GenericService } from "../../providers/generic.service";
import { GlobalService } from "../../providers/global.service";
import { Router, RouterEvent, NavigationStart } from "@angular/router";
import { AuthGuard } from "../../providers/auth-guard";
import { AuthService } from "src/app/providers/auth.service";
import { Events, MenuController, NavController } from "@ionic/angular";
@Component({
  selector: "app-menu",
  templateUrl: "./menu.component.html",
  styleUrls: ["./menu.component.scss"],
  host: {
    class: "app-menu",
  },
})
export class MenuComponent implements OnInit {
  menuItems: any;
  subscription: any;
  gs = GlobalService;

  constructor(
    private router: Router,
    private authGuard: AuthGuard,
    private navCtrl: NavController,
    private authService: AuthService,
  ) {
    router.events.subscribe((event: RouterEvent) => {
      if (event instanceof NavigationStart) this.showHidePages();
    });
  }

  getLiClasses(item: any) {
    return {
      "has-sub": item.sub,
      active: this.router.url === "/" + item.path,
      "menu-item-group": item.groupTitle,
      disabled: item.disabled,
    };
  }
  getStyles(item: any) {
    return {
      background: item.bg,
      color: item.color,
    };
  }

  ngOnInit(): void {
    this.menuItems = GenericService.clone(MENU);
    this.showHidePages();
  }

  toggle(event: Event, item: any, el: any) {
    event.preventDefault();

    let items: any[] = el.menuItems;

    if (item.active) {
      item.active = false;
      if (item.sub && item.sub.length > 0) {
        item.sub.forEach((x) => (x.visible = false));
      }
    } else {
      items.forEach((x) => {
        x.active = false;
        if (x.sub && x.sub.length > 0) {
          x.sub.forEach((y) => {
            y.active = false;
            y.visible = false;
          });
        }
      });
      item.active = true;
      if (item.sub && item.sub.length > 0) {
        item.sub.forEach((x) => (x.visible = true));
      }
      if (
        (this.gs.user.Designation == 1 || this.gs.user.Designation == 2) &&
        this.gs.user.Role == 3 &&
        item.title == "DSC" &&
        item.role == 3
      ) {
        item.visible = true;
        item.sub[1].visible = false;
      }
      if (
        this.gs.user.Designation < 9 &&
        item.role == 1 &&
        item.title == "Accounting"
      ) {
        item.visible = true;
        item.sub[0].visible = false;
      }
    }
  }
  togglesub(event: Event, item: any, el: any) {
    event.preventDefault();

    let items: any[] = el.menuItems;

    item.active = true;
  }
  async showHidePages() {
    setTimeout(() => {
      if (this.gs.user != null) {
        this.menuItems.forEach((item: any) => {
          if (
            (this.gs.user.Designation == 100 ||
              this.gs.user.Designation == 200) &&
            (item.title == "Users" ||
              item.title == "Accounting" ||
              item.title == "Master")
          )
            item.visible = false;
          else if (
            (this.gs.user.Designation == 1 || this.gs.user.Designation == 2) &&
            this.gs.user.Role == 3 &&
            item.title == "DSC" &&
            item.role == 3
          ) {
            item.visible = true;
            item.sub[1].visible = false;
          } else
            item.visible = this.authGuard.canViewPagewithrole(
              item.path,
              item.role,
            );
        });
      }
    });
  }

  open(item) {
    if (!item.sub) this.authGuard.navigate(item.path);
    else {
      if (item.sub.filter((x) => x.active).length > 0) {
        let path = item.sub.filter((x) => x.active)[0].path;
        this.authGuard.navigate(path);
      }
    }
  }

  ngOnDestroy() {
    if (this.subscription) this.subscription.unsubscribe();
  }
}
